import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalService } from 'src/app/_services/global.service';
import { GAME_INFO, GameInfoContent } from '../../../data/game-info-content';

@Component({
  selector: 'app-game-info-modal',
  templateUrl: './game-info-modal.component.html',
  styleUrls: ['./game-info-modal.component.scss']
})
export class GameInfoModalComponent implements OnInit, OnDestroy {
  @Input() gameType: string = '';
  @Output() close = new EventEmitter<void>();

  currLang: any = 'en';
  content: GameInfoContent | null = null;
  private destroy$ = new Subject<void>();

  constructor(private globalService: GlobalService) {}

  ngOnInit(): void {
    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => this.currLang = lang);
    this.content = GAME_INFO[this.gameType] || null;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
